<template>
  <div class="p-customer-wrap">
    <div class="c-search" data-layer-hidden>
      <h2 class="sr-only">검색 영역</h2>
      <div class="search-form">
        <input
          type="text"
          id="searchQuery"
          title="검색"
          class="search-input"
          autocomplete="off"
          placeholder="키워드 입력"
          v-model="data.search_Keyword.searchKeyword"
          @keyup.enter="btnCmd('keyWord')"
        />
        <button type="button" class="search-cancel" @click="btnCmd('reset')">
          <i class="c-icon icon-large-x"></i>
          <span class="sr-only">검색어 재입력</span>
        </button>
        <button type="button" class="search-submit" @click="btnCmd('keyWord')">
          <span class="sr-only">검색</span>
        </button>
      </div>
    </div>
  </div>

  <!-- 키워드 -->
  <div class="hot-keyword">
    <strong class="label">인기 키워드</strong>
    <div class="keywords">
      <button
        v-for="(item, idx) in data.faq.kwdList"
        :key="idx"
        type="button"
        class="keyword-item"
        @click="btnCmd('keyWord', { fasWord: item.kwdNm })"
      >
        #{{ item.kwdNm }}
      </button>
    </div>
  </div>

  <!-- D: tabs -->
  <div class="c-square-tabs" v-if="data.tabKeyFlag">
    <ul>
      <!-- D: 활성화시 is-active 및 aria-selected 추가 -->
      <li class="tab-item">
        <button
          type="button"
          :class="[
            'tab-anchor',
            {
              'is-active': data.tabIndex === 0,
            },
          ]"
          role="tab"
          @click="btnCmd('tabClick', { index: 0 })"
          :aria-selected="data.tabIndex === 0"
        >
          TOP 10
        </button>
      </li>
      <li class="tab-item">
        <button
          type="button"
          :class="[
            'tab-anchor',
            {
              'is-active': data.tabIndex === 1,
            },
          ]"
          role="tab"
          @click="btnCmd('tabClick', { index: 1 })"
          :aria-selected="data.tabIndex === 1"
        >
          주문
        </button>
      </li>
      <li class="tab-item">
        <button
          type="button"
          :class="[
            'tab-anchor',
            {
              'is-active': data.tabIndex === 2,
            },
          ]"
          role="tab"
          @click="btnCmd('tabClick', { index: 2 })"
          :aria-selected="data.tabIndex === 2"
        >
          제품
        </button>
      </li>
      <li class="tab-item">
        <button
          type="button"
          :class="[
            'tab-anchor',
            {
              'is-active': data.tabIndex === 3,
            },
          ]"
          role="tab"
          @click="btnCmd('tabClick', { index: 3 })"
          :aria-selected="data.tabIndex === 3"
        >
          사이트
        </button>
      </li>
      <li class="tab-item">
        <button
          type="button"
          :class="[
            'tab-anchor',
            {
              'is-active': data.tabIndex === 4,
            },
          ]"
          role="tab"
          @click="btnCmd('tabClick', { index: 4 })"
          :aria-selected="data.tabIndex === 4"
        >
          재고문의
        </button>
      </li>
      <li class="tab-item">
        <button
          type="button"
          :class="[
            'tab-anchor',
            {
              'is-active': data.tabIndex === 5,
            },
          ]"
          role="tab"
          @click="btnCmd('tabClick', { index: 5 })"
          :aria-selected="data.tabIndex === 5"
        >
          기타
        </button>
      </li>
    </ul>
  </div>

  <!-- D: 키워드 검색시 탭 숨기고, 검색결과 텍스트 노출 -->
  <div class="c-search-result-keyword" v-if="!data.tabKeyFlag">
    <p class="text">
      <b class="color-primary">"{{ data.keyWord.setWord }}"</b>
      검색결과 총
      <b class="color-primary">{{ data.search_Keyword.totalCount }}</b
      >개
    </p>
    <button
      type="button"
      class="c-util-button type-primary type-small"
      @click="btnCmd('allReset')"
    >
      <span class="bold">새로고침</span>
    </button>
  </div>

  <div class="c-accordion-list" data-accordion-wrap>
    <ul>
      <li v-for="(item, idx) in data.faq.list" :key="idx">
        <button
          type="button"
          class="accordion-button"
          data-accordion-trigger
          :aria-expanded="data.faq.expendIndex === idx"
          :aria-controls="'act' + idx"
          @click="btnCmd('expendClick', { index: idx, faqSn: item.faqSn })"
        >
          <span
            v-if="item.faqTypeCd == '10'"
            class="c-flag type-board type-blue"
            >주문</span
          >
          <span
            v-if="item.faqTypeCd == '20'"
            class="c-flag type-board type-teal"
            >제품</span
          >
          <span
            v-if="item.faqTypeCd == '30'"
            class="c-flag type-board type-purple"
            >사이트</span
          >
          <span
            v-if="item.faqTypeCd == '40'"
            class="c-flag type-board type-green"
            >재고문의</span
          >
          <span
            v-if="item.faqTypeCd == '50'"
            class="c-flag type-board type-olive"
            >기타</span
          >
          <strong class="title" v-html="sanitizeHTML(item.faqTitleNm)"></strong>
        </button>
        <div
          :id="'act' + idx"
          class="accordion-content"
          data-accordion-content
          :aria-hidden="data.faq.expendIndex !== idx"
          v-html="item.faqCn"
        ></div>
      </li>
    </ul>
  </div>

  <!-- D: no data -->
  <div v-if="!data.faqListFlag" class="c-no-data-box">
    <div class="icon-box">
      <i class="c-icon icon-nodata size-large"></i>
    </div>
    <p class="text">조회 결과가 없습니다.</p>
  </div>

  <!-- D : pageing area -->
  <template v-if="data.notListFlag">
    <Pagination
      ref="paginationEl"
      :total-pages="data.search_Keyword.totalPage"
      :per-page="data.search_Keyword.limit"
      :show-select="true"
      @page-change="handlePageChange"
      @items-per-page-change="handleItemsPerPageChange"
    />
  </template>
  <!-- // D : pageing area -->

  <div class="c-btn-area has-fixed-visible is-fixed" data-bottom-fixed>
    <a
      href="#"
      class="c-button type-primary flex-auto"
      @click="btnCmd('router')"
      style="--btn-width: 280px"
    >
      <span>문의작성</span>
    </a>
  </div>
</template>

<script setup name="faqListTab">
import { onMounted, reactive, inject, ref } from "vue";
import { useRouter } from "vue-router";
import { api } from "@/plugins/api";
import * as cmUtil from "@/utils/cmUtil.js";

import Pagination from "@/components/paintpro/base/pagination.vue";

const router = useRouter();
const url = inject("url_prefix");
const paginationEl = ref(null);

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  tabIndex: 0, // 탭 구분 값(TOP, 주문, 제품, 사이트, 재고문의, 기타)
  tabKeyFlag: true, // 탭,키워드 검색 구분
  faqListFlag: true, // 조회 시 리스트 유무
  notListFlag: false, // 키워드 검색 시 리스트가 없는 경우
  faq: {
    expendIndex: -1, //아코디언 index
    list: [],
    kwdList: [],
    loading: false,
  },
  keyWord: {
    list: [],
    setWord: "",
  },
  search_init: {
    val: 1,
    tabType: "top",
    faqTypeCd: null,
  },
  // tap
  search_type: {
    val: 1, //1 : top10, 2: 주문,제품,사이트,제고문의,기타
    tabType: "", //top : top10, type: 주문,제품,사이트,제고문의,기타
    faqTypeCd: null,
  },
  // 키워드
  search_Keyword: {
    val: 3,
    tabType: "key",
    searchKeyword: "",
    page: 1, // 현재 페이지
    limit: 20, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
  },
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  searchCmd("search", { search: data.search_init });
});

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", params = {}) {
  // 자주 찾는 질문 TOP10
  if (cmd === "search") {
    const res = await api.post(`${url}/custCenter/selectQna01`, params.search);
    if (params["page"] == null || params["page"] == 1) {
      paginationEl.value?.setCurrentPage(1);
    }

    if (params.val != 1 || params.val != 2) {
      data.search_Keyword.page = params["page"] || 1;
      data.search_Keyword.totalCount = res.data.totalCount;
      data.search_Keyword.totalPage = data.search_Keyword.totalCount
        ? Math.ceil(data.search_Keyword.totalCount / data.search_Keyword.limit)
        : 0;

      data.keyWord.setWord = data.search_Keyword.searchKeyword;
    }
    data.faq.list = res.data.list;

    // 조회 시 리스트 유무
    if (res.data.totalCount > 0) {
      data.faqListFlag = true;

      if (data.tabKeyFlag == true) {
        data.notListFlag = false;
      }
    } else {
      data.faqListFlag = false;
      data.notListFlag = false;
    }
  }

  // 인기 키워드
  const resKwd = await api.post(`${url}/custCenter/selectQna02`, {});
  data.faq.kwdList = resKwd.data;
}

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", params = {}) {
  // 아코디언 활성화
  if (cmd === "expendClick") {
    if (data.faq.expendIndex == params.index) {
      data.faq.expendIndex = -1;
    } else {
      data.faq.expendIndex = params.index;
      const res = await api.post(`${url}/custCenter/updateInqCnt`, {
        faqSn: params.faqSn,
        type: "faq",
      });
      if (res.resultCode == 200) {
        return;
      }
    }
  }
  // 인기 키워드 검색
  else if (cmd === "keyWord") {
    data.tabKeyFlag = false;
    data.notListFlag = true;
    if (data.search_Keyword.searchKeyword.length > 0) {
      if (params.fasWord != null) {
        data.search_Keyword.searchKeyword = params.fasWord;
      }
    } else if (params.fasWord != null) {
      data.search_Keyword.searchKeyword = params.fasWord;
    }
    searchCmd("search", { search: data.search_Keyword });
  }
  // 탭 선택
  else if (cmd === "tabClick") {
    data.tabKeyFlag = true;

    data.tabIndex = params.index;
    if (params.index == 0) {
      data.search_type.faqTypeCd = null;
    } else if (params.index == 1) {
      data.search_type.faqTypeCd = "10";
    } else if (params.index == 2) {
      data.search_type.faqTypeCd = "20";
    } else if (params.index == 3) {
      data.search_type.faqTypeCd = "30";
    } else if (params.index == 4) {
      data.search_type.faqTypeCd = "40";
    } else if (params.index == 5) {
      data.search_type.faqTypeCd = "50";
    }

    data.search_type.val = 2;
    data.search_type.tabType = "type";
    data.faq.expendIndex = -1;

    searchCmd("search", { search: data.search_type });
  }
  // 문의하기로 이동
  else if (cmd == "router") {
    router.push({
      name: "/paintpro/custCenterList/reqList",
    });
  }
  // 검색에 X 표기
  else if (cmd == "reset") {
    data.search_Keyword.searchKeyword = "";
  }
  // 초기화
  else if (cmd == "allReset") {
    data.search_Keyword.searchKeyword = "";
    data.tabKeyFlag = true;
    data.tabIndex = 0;
    searchCmd("search", { search: data.search_init });
  }
}

/**********************
 * 페이징 모음
 *********************/
function handlePageChange(page) {
  data.search_Keyword.page = page;
  searchCmd("search", { search: data.search_Keyword });
}
function handleItemsPerPageChange(perPage) {
  data.search_Keyword.limit = perPage;
  searchCmd("search", { search: data.search_Keyword });
}

// script 태그와 이벤트 핸들러 제거
function sanitizeHTML(html) {
  return cmUtil.sanitizeHTML(html);
}
</script>
